import React from "react";
import _ from '../../../utils/ObjectUtils';
import Tippy from '@tippy.js/react'
import { I18n } from 'react-redux-i18n';

const StatusBarCell = ({
    color = null,
    id = ""
}) => {
    return (
        <Tippy
            content={I18n.t('dataTable.status.' + id.toLowerCase())}
            placement="top"
            flip={false}
            theme="google"
        >
            <div
                style={{
                    width: '0.3rem',
                    height: '2rem',
                    backgroundColor: _.isNil(color) ?
                        possibleStatus.uncertain.color :
                        color
                }} />
        </Tippy>
    )
}

const possibleStatus = {
    active: {
        id: 'ACTIVE',
        color: '#94ce54'
    },
    inactive: {
        id: 'INACTIVE',
        color: '#d17681'
    },
    pending: {
        id: 'PENDING',
        color: '#f7c168'
    },
    uncertain: {
        id: 'UNCERTAIN',
        color: '#afc6e1'
    },
    enabled: {
        id: 'ENABLED',
        color: '#94ce54'
    },
    disabled: {
        id: 'DISABLED',
        color: '#d17681'
    },
    online: {
        id: 'ONLINE',
        color: '#94ce54'
    },
    offline: {
        id: 'OFFLINE',
        color: '#d17681'
    },
    disconnected: {
        id: 'DISCONNECTED',
        color: '#afc6e1'
    }
}

export {possibleStatus};
export default StatusBarCell;